import http, { url } from '../../http'

const API_URL = "coexistence-committee"

class CommiteeAPI {

  async saveAct(act) {
    const response = await http(`${API_URL}/save`, 'POST', act)
    return response || null
  }

  async updateAct(committeeID, act) {
    const response = await http(`${API_URL}/update/${committeeID}`, 'PUT', act)
    return response || null
  }

  async getAct(companyID) {
    const response = await http(`${API_URL}/companies/candidates/${companyID}`, 'GET')
    return response || null
  }

  async getActById(committeeID) {
    const response = await http(`${API_URL}/acta_empleados/${committeeID}`, 'GET')
    return response.Copasst.data || null
  }

  async getActByCompany(companyID, page) {
    const response = await http(`${API_URL}/acts-list/${companyID}?page=${page}`, 'GET')
    return response || null
  }
  
  getConformationAct(companyID, actID) {
    return url(`coexistence-committee/downloadpdf/${companyID}/${actID}`)
  }

  getWordAct(actID) {
    let user = JSON.parse(localStorage.getItem('user'))

    return url(`coexistence-member/downloadword/${actID}?&access_token=${user.token}`)
  }

}

export default new CommiteeAPI()